/* Estimateur de prix LCR Services.
   Règles et prix repris à l'identique de la page « Estimation de tarif » actuelle (grille publique) :
   - les forfaits d'ouverture (porte claquée, porte fermée à clé) incluent le déplacement, de jour comme de nuit ;
   - boîte aux lettres, cylindre et serrure multipoints ne l'incluent pas ;
   - la boîte aux lettres et la serrure multipoints ont un prix fixe, sans distinction jour / nuit. */
(function () {
  var ZONES = {
    rouen: { label: 'Rouen', price: 40 },
    agglo: { label: 'Agglomération rouennaise', price: 42 },
    far: { label: 'Secteur élargi', price: 44 }
  };
  var ISSUES = {
    claquee: { label: 'Ouverture de porte claquée', day: { price: 99, includesTravel: true }, night: { price: 140, includesTravel: true } },
    fermee: { label: 'Ouverture de porte fermée à clé', day: { price: 143, includesTravel: true }, night: { price: 160, includesTravel: true } },
    bal: { label: 'Ouverture de boîte aux lettres', day: { price: 47 }, night: { price: 47 }, fixed: true },
    cylindre: { label: 'Main d’œuvre et cylindre standard', day: { price: 92 }, night: { price: 118 } },
    multipoints: { label: 'Pose d’une serrure multipoints', day: { price: 267 }, night: { price: 267 }, fixed: true }
  };

  function euro(n) { return n + ' €'; }

  document.querySelectorAll('[data-lcr-est]').forEach(function (root) {
    var timeGroup = root.querySelector('[data-est-time]');
    var elLabel = root.querySelector('[data-est-label]');
    var elDetail = root.querySelector('[data-est-detail]');
    var elTotal = root.querySelector('[data-est-total]');
    var elReq = root.querySelector('[data-est-request]');

    function val(name) {
      var r = root.querySelector('input[name="' + name + '"]:checked');
      return r ? r.value : null;
    }

    function update() {
      var zone = ZONES[val('zone')] || ZONES.rouen;
      var issue = ISSUES[val('issue')] || ISSUES.claquee;
      var night = val('time') === 'night';
      var slot = issue.fixed ? issue.day : (night ? issue.night : issue.day);
      var travel = !!slot.includesTravel;

      if (timeGroup) timeGroup.hidden = !!issue.fixed;

      var when = issue.fixed ? '' : (night ? ', nuit ou week-end' : ', de jour');
      elLabel.textContent = issue.label + when;
      elDetail.textContent = travel
        ? 'Déplacement inclus dans le forfait'
        : euro(slot.price) + ' + déplacement ' + zone.label + ' ' + euro(zone.price);
      elTotal.textContent = euro(travel ? slot.price : slot.price + zone.price);

      if (elReq) {
        var asked = { claquee: 'Ouverture de porte', fermee: 'Ouverture de porte', bal: 'Autre', cylindre: 'Remplacement de serrure', multipoints: 'Remplacement de serrure' }[val('issue')] || 'Autre';
        var summary = elTotal.textContent + ' (' + elLabel.textContent + ', ' + zone.label + ')';
        elReq.href = '/pages/demande-de-depannage?issue=' + encodeURIComponent(asked) + '&estimation=' + encodeURIComponent(summary);
      }
    }

    root.addEventListener('change', update);
    update();
  });
})();
